import type { ImageSourcePropType } from "react-native";

// Brand-safe kit photo, shared by all of the at-home semen analysis kits.
// Bundled locally (not a remote URL) so it ships with the app.
const SEMEN_KIT =
  require("../../assets/images/semen-analysis-kit.png") as ImageSourcePropType;

const LOCAL_PRODUCT_IMAGES: Record<string, ImageSourcePropType> = {
  "product-semen-core": SEMEN_KIT,
  "product-semen-post-vasectomy": SEMEN_KIT,
  "product-semen-vasectomy-reversal": SEMEN_KIT,
  "product-semen-antisperm": SEMEN_KIT,
  "product-semen-dna-frag": SEMEN_KIT,
  "product-semen-dna-methylation": SEMEN_KIT,
  "product-semen-complete": SEMEN_KIT,
};

/** Bundled image for a product (our own kits), or undefined to fall back to its imageUrl. */
export function getLocalProductImage(
  productId: string,
): ImageSourcePropType | undefined {
  return LOCAL_PRODUCT_IMAGES[productId];
}
